/**
 * @generated SignedSource<<4d1b5a4becae2390dbee1d27b6964ff0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductStatus = "archived" | "draft" | "published" | "unlisted" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AdminExperiencesListTableRowFragment$data = {
  readonly attendees: {
    readonly totalCount: number;
  };
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly status: ProductStatus;
  readonly " $fragmentSpreads": FragmentRefs<"ExperienceAdminDropdownFragment" | "ProductTypeTagFragment" | "ProductWithDetailsFragment">;
  readonly " $fragmentType": "AdminExperiencesListTableRowFragment";
};
export type AdminExperiencesListTableRowFragment$key = {
  readonly " $data"?: AdminExperiencesListTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminExperiencesListTableRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminExperiencesListTableRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductMembershipNodeConnection",
      "kind": "LinkedField",
      "name": "attendees",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExperienceAdminDropdownFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductTypeTagFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductWithDetailsFragment"
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "452e97b0ebbe6c92d6b30ae93cc38608";

export default node;
